interface NavigationLoadingStore {
  commit: (type: string) => void;
}

export const startRouteLoading = (store: NavigationLoadingStore): void => {
  store.commit('navigation/START_ROUTE_LOADING');
};

export const stopRouteLoading = (store: NavigationLoadingStore): void => {
  store.commit('navigation/STOP_ROUTE_LOADING');
};
